'use strict';

module.exports = {
  PRO: 2,
  API: 3,
  SUPER: 5,
  BASIC: 11,
  BOUTIQUE_BRAND: 14
};